<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-09-28 00:32:26
 * @LastEditors: 诺
 * @LastEditTime: 2022-11-04 14:16:10
 * @Description: file content
 -->
<template>
  <div class="ActBaseMusic">
    <div
      class="music"
      @click="clickMusic"
      :class="{'act_animate_rotate_config':isRotate}"
      :style="option&&option.style"
    >
      <img
        :src="(option&&option.imgSrc)?option.imgSrc:'http://assets.rurushishi.com/activies/zdfzh/music.png'"
        alt
      />
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    // audioSrc   必填
    // imgSrc     不必填
    // style      不必填
    // autoPlay   不必填  默认true
    option: Object
  },
  data() {
    return {
      isRotate: false
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 点击音乐开关
    clickMusic() {
      this.$audio.add("bg", this.option.audioSrc);
      if (this.$audio.bg.getIsPlay()) {
        // 继续播放
        this.$audio.bg.play(null, () => {
          this.isRotate = true;
        });
      } else {
        // 停止播放
        this.$audio.bg.pause(() => {
          this.isRotate = false;
        });
      }
    },
  },
  created() {
    var hiddenProperty ='hidden' in document ?'hidden' :
        'webkitHidden' in document ?'webkitHidden' :
        'mozHidden' in document ?'mozHidden' :
        null;
        const _self= this
    if (hiddenProperty) {
      var visibilityChangeEvent = hiddenProperty.replace(/hidden/i,'visibilitychange');
      var onVisibilityChange =function() {
        console.log(document[hiddenProperty])
          if (document[hiddenProperty]) {
            _self.$audio.bg.pause(() => {
              _self.isRotate = false;
          });
          }else{
            setTimeout(function () {
              _self.$audio.bg.play(null, () => {
                _self.isRotate = true;
            });
            },100);
          }
        }
    }
    document.addEventListener(visibilityChangeEvent, onVisibilityChange);


    this.$wx.ready(() => {
      if (!this.option) {
        console.warn("ActBaseMusic组件 缺少option参数");
        return;
      }
      if (!this.option.audioSrc) {
        console.warn("ActBaseMusic组件 缺少option.audioSrc参数");
        return;
      }
      this.$audio.add("bg", this.option.audioSrc);
      if (this.option.autoPlay == false) {
        console.log("ActBaseMusic组件 音乐需手动播放");
      } else {
        this.$audio.bg.pause(() => {
          this.isRotate = false;
        });
        this.$audio.bg.play(null, () => {
          this.isRotate = true;
        });
      }
    });
  },
  mounted() {}
};
</script>
<style lang="css" scoped>
.music {
  position: fixed;
  top: 16px;
  right: 16px;
  width: 40px;
  height: 40px;
  z-index: 100;
}

.music > img {
  width: 100%;
  height: 100%;
}
</style>